"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteAccountNumber = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("react");
const useSite_1 = require("./useSite");
function useSiteAccountNumber() {
    const site = useSite_1.useSite();
    const locationIdOrEmpty = site.id.type === 'location' ? site.id.locationId : '';
    const res = client_1.useQuery(LOCATION_QUERY, {
        variables: { locationId: locationIdOrEmpty },
        context: { locationId: locationIdOrEmpty },
        skip: site.id.type !== 'location',
    });
    return react_1.useMemo(() => {
        var _a, _b;
        if (site.id.type === 'prospect') {
            return { loading: false, accountNumber: site.id.accountNumber };
        }
        else if (site.id.type === 'location') {
            return Object.assign(Object.assign({}, res), { accountNumber: (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.accountId });
        }
        else {
            throw new Error('Unknown Site');
        }
    }, [res, site.id]);
}
exports.useSiteAccountNumber = useSiteAccountNumber;
const LOCATION_QUERY = client_1.gql `
  query LocationAccountNumber($locationId: String!) {
    location(locationId: $locationId) {
      key
      accountId
    }
  }
`;
//# sourceMappingURL=useSiteAccountNumber.js.map